import type { ShortsFilters } from '~/core/entities/property/filters';
import type { Ref } from 'vue';

import {
	applyHomeShortsRule,
	withSimilarRecommendationParams
} from '~/composables/useShortsFilters/featuredVideosFilterRules';
import { computed, ref } from 'vue';

export const HOME_SHORTS_RECOMMENDED_TITLE = 'Vídeos recomendados para você';
export const HOME_SHORTS_DEFAULT_TITLE = 'Descubra imóveis em vídeo';

export function getHomeShortsFilters(
	referenceProperty?: string | null
): ShortsFilters {
	const similarFilters = withSimilarRecommendationParams({}, referenceProperty);

	if (similarFilters.referenceProperty) {
		return similarFilters;
	}

	return applyHomeShortsRule({}, false, undefined);
}

export function getHomeShortsTitle(
	referenceProperty: string | null | undefined,
	isFallbackActive: boolean
): string {
	const filters = getHomeShortsFilters(referenceProperty);

	return filters.referenceProperty && !isFallbackActive
		? HOME_SHORTS_RECOMMENDED_TITLE
		: HOME_SHORTS_DEFAULT_TITLE;
}

export function useHomeShortsRecommendation(
	lastViewedProperty: Ref<string | null | undefined>
) {
	const isFallbackActive = ref(false);
	const filters = computed<ShortsFilters>(() =>
		getHomeShortsFilters(lastViewedProperty.value)
	);
	const title = computed(() =>
		getHomeShortsTitle(lastViewedProperty.value, isFallbackActive.value)
	);

	function handleFallbackUpdate(value: boolean): void {
		isFallbackActive.value = value;
	}

	return {
		filters,
		title,
		isFallbackActive,
		handleFallbackUpdate
	};
}
